import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeSales: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Sales',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Product demo',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'Customer training',
        },
        {
            label: 'Customer onboarding',
        },
        {
            label: 'Product update',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'How-to guide',
        },
        {
            label: 'Customer comms',
        },
        {
            label: 'Other',
        },
    ],
};
